import { MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER } from "../lib/api";

export default function WhatsAppButton() {
  const text = encodeURIComponent("Bonjou! Mwen gen yon kesyon sou yon pwodwi John Elektwo.");
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      className="je-whatsapp-btn"
      aria-label="Contacter sur WhatsApp"
      data-testid="whatsapp-button"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
}
